<template>
  <form>
    <v-select outlined
              dense
              :items="questionsListA"
              v-model="model.sq_A"
              label="Question 1"
    />
    <v-text-field v-if="isSelectedCustomA"
                  dense
                  outlined
                  label="Please enter your question"
                  clearable
                  v-model="model.sq_A_custom"
                  v-validate="'required'"
                  name="Question 1 Custom"
                  data-vv-as="Question 1"
                  :error-messages="errors.collect('Question 1 Custom')"
    />
    <v-text-field outlined
                  dense
                  v-model="model.sqa_A"
                  v-validate="'required'"
                  :error-messages="errors.collect('Answer 1')"
                  name="Answer 1"
                  label="Answer 1"
                  maxlength="80"
    />
    <v-select outlined
              dense
              :items="questionsListB"
              v-model="model.sq_B"
              label="Question 2"
    />
    <v-text-field v-if="isSelectedCustomB"
                  dense
                  outlined
                  label="Please enter your question"
                  clearable
                  v-model="model.sq_B_custom"
                  v-validate="'required'"
                  name="Question 2 Custom"
                  data-vv-as="Question 2"
                  :error-messages="errors.collect('Question 2 Custom')"
    />
    <v-text-field outlined
                  dense
                  v-model="model.sqa_B"
                  v-validate="'required'"
                  :error-messages="errors.collect('Answer 2')"
                  name="Answer 2"
                  label="Answer 2"
                  maxlength="80"
    />
    <gg-btn dark
           color="green"
           class="mt-2 ml-0"
           :loading="loading"
           tile
           @click="saveAnswers"
    >
      Save Answers
    </gg-btn>
  </form>
</template>

<script>
export default {
  name: 'EditQuestions',
  props: {
    questions: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      model: {
        sq_A: '',
        sq_A_custom: '',
        sq_B: '',
        sq_B_custom: '',
        sqa_A: '',
        sqa_B: '',
      },
    }
  },
  computed: {
    questionsListA () {
      return this.questions.filter(x => {
        if (x !== this.model.sq_B || x === 'Custom') {
          return x
        }
      })
    },
    questionsListB () {
      return this.questions.filter(x => {
        if (x !== this.model.sq_A || x === 'Custom') {
          return x
        }
      })
    },
    isSelectedCustomA () {
      return this.model.sq_A === 'Custom'
    },
    isSelectedCustomB () {
      return this.model.sq_B === 'Custom'
    }
  },
  mounted () {
    this.setDefaultQuestions()
  },
  methods: {
    setDefaultQuestions () {
      this.model.sq_A = this.questions[0]
      this.model.sq_B = this.questions[1]
    },
    async saveAnswers () {
      if (!await this.$validator.validateAll()) return
      const dirtyQuestions = Object.assign({}, this.model)
      const questions = {}

      if (this.isSelectedCustomA) {
        questions.sq_A = dirtyQuestions.sq_A_custom
        questions.sqa_A = dirtyQuestions.sqa_A
      } else {
        questions.sq_A = dirtyQuestions.sq_A
        questions.sqa_A = dirtyQuestions.sqa_A
      }

      if (this.isSelectedCustomB) {
        questions.sq_B = dirtyQuestions.sq_B_custom
        questions.sqa_B = dirtyQuestions.sqa_B
      } else {
        questions.sq_B = dirtyQuestions.sq_B
        questions.sqa_B = dirtyQuestions.sqa_B
      }

      this.$emit('save', questions)
    }
  },
}
</script>
